import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: true,
  imports: [RouterModule, RouterModule],
  template: `
    @if (tags.length > 0) {
    <div class="tags-container">
      @for (tag of tags; track $index) {
      <span class="tag">{{ tag }}</span>
      }
    </div>
    }
  `,
  styles: [
    `
      .tags-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 4px;
      }

      .tag {
        display: inline-block;
        background-color: #ebf5fe;
        color: #333;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 13px;
        height: 24px;
        line-height: 20px;
        text-align: center;
      }
    `,
  ],
})
export class TableTagsRendererComponent implements ICellRendererAngularComp {
  tags: string[] = [];

  private readonly cdr = inject(ChangeDetectorRef);

  agInit(params: ICellRendererParams): void {
    this.updateTags(params.value);
    this.cdr.detectChanges();
  }

  refresh(params: ICellRendererParams) {
    this.updateTags(params.value);
    this.cdr.detectChanges();
    return true;
  }

  private updateTags(value: any): void {
    if (typeof value === 'string') {
      this.tags = value ? value.split(',').map((tag) => tag.trim()) : [];
    } else if (Array.isArray(value)) {
      this.tags = value
        .map((v) => {
          if (typeof v === 'string') return v;
          if (typeof v === 'number') return String(v);
          if (v && typeof v === 'object') {
            const obj: any = v;
            const candidate = obj?.name ?? obj?.label ?? obj?.title ?? obj?.value ?? '';
            return typeof candidate === 'string' ? candidate : String(candidate ?? '');
          }
          return v ? String(v) : '';
        })
        .map((t) => (t || '').trim())
        .filter(Boolean);
    } else {
      this.tags = value ? [value.toString()] : [];
    }
  }
}
